<template>
  <!-- <div class="nft-cotainer" fluid> -->
    <v-container class="white-wrapper" fluid>

    
    <div class="nft-title" style="max-width: 25rem; margin: 0 auto">

      <div class="nft-btn">
        <router-link to="/nft" class="back-icon">
          <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
        </router-link>

        <button type="button" class="share">
          <img class="share-svg" src="@/assets/icon/share.svg" />
        </button>
      </div>

      <div class="nft-img">
        <img src="@/assets/img/kan.png" alt="">
      </div>

      <div class="nft-info">
        <div class="state">진행중</div>
        <div class="nft_name">KAN</div>

        <div class="calendar">
          <div class="timer">
            <div class="days timer_shape">
              <span>00</span>
              <span>Days</span>
            </div>
            <span class="timer_icon">:</span>
            <div class="hours timer_shape">
              <span>00</span>
              <span>Hours</span>
            </div>
            <span class="timer_icon">:</span>
            <div class="Min timer_shape">
              <span>00</span>
              <span>Minutes</span>
            </div>
            <span class="timer_icon">:</span>
            <div class="sec timer_shape">
              <span>00</span>
              <span>Seconds</span>
            </div>
          </div>

          <div class="date">
            진행기간 : <span>2022.11.11 14:00 ~ 11.30 14:00</span>
          </div>
        </div>

        <div class="selling_info">

          <div class="selling_info-list">
            <div class="selling-info_title">판매가</div>
            <div class="selling-info_content">
              <div class="nft_point"> <span>0.125</span> ETH</div>
              <div class="nft_price"> ≈ <span>0.125</span> KRW</div>
            </div>
          </div>

          <div class="selling_info-list">
            <div class="selling-info_title">잔여 수량</div>
            <div class="selling-info_content">
              <span>16</span>개 / <span>20</span>개
            </div>
          </div>

          <div class="selling_info-list">
            <div class="selling-info_title">보유 잔고</div>
            <div class="selling-info_content point">
              <span>0.10809360</span>
              ETH
              <img src="@/assets/icon/swap_2.svg" alt="reset icon" class="reset_icon">
            </div>
          </div>

          <div class="selling_info-list">
            <div class="selling-info_title">구매 수량</div>
            <div class="selling-info_content">2개</div>
          </div>

        </div>
      </div>

    </div>
  </div>
</v-container>
</template>

<script>
  export default {
    components: {},
    computed: {

    },
    methods: {

    },
    created() {

    }
  }
</script>

<style lang="scss" scoped>
  .nft-cotainer {
    padding: 0 16px;
  }

  // 상단 icon
  .nft-btn {
    display: flex;
    justify-content: space-between;
    margin-top: 38px;
  }

  .back-svg {
    width: 23px;
    height: 23px;
  }

  .share-svg {
    width: 26px;
    height: 26px;
  }

  // image
  .nft-img {
    width: 260px;
    height: 400px;
    margin: 0 auto;
  }

  .nft-img>img {
    width: 100%;
  }

  // nft 상세 내용
  .nft-info .state {
    font-size: 14px;
    color: #fff;
    background-color: #4D4D4D;
    width: 55px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 5px;
    margin-top: 32px;
  }

  .nft-info .nft_name {
    font-size: 30px;
    margin-top: 8px;
  }

  .nft-info .calendar {
    text-align: center;
  }

  .nft-info .calendar,
  .selling_info {
    width: 100%;
    border-bottom: 0.5px solid #e0e0e0b0;
  }

  .timer {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }

  .timer_shape {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 65px;
    height: 67px;
    background-color: #EBEBEB;
    border-radius: 10px;
  }

  .timer_shape span:first-child {
    font-size: 21px;
    font-weight: 500;
  }

  .timer_shape span:last-child {
    font-size: 13px;
  }

  .timer_icon {
    font-size: 37px;
    font-weight: 300;
    margin: 0 7px;
  }

  .nft-info .date {
    margin: 14px 0 25px;
  }

  .selling_info {
    margin-top: 25px;
  }

  .selling_info-list {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .selling-info_title {
    color: #747474;
  }

  .selling-info_content {
    text-align: right;
  }

  .selling-info_content .nft_point {
    font-size: 20px;
  }

  .selling-info_content .nft_price {
    color: #747474;
  }

  .selling-info_content.point {
    display: flex;
  }

  .selling-info_content .reset_icon {
    margin-left: 8px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
</style>